<section>
  <h3 class="mt-0">Abo</h3>

  @if (notice()) {
    <p-message
      severity="info"
      styleClass="mb-3"
      data-cy="sana-tp-subscription-notice">{{ notice() }}</p-message>
  }

  @switch (pageState()) {
    @case ('error') {
      <div class="sana-card">
        <p-message severity="error">Abo-Status konnte nicht geladen werden</p-message>

        <p-button
          styleClass="mt-3"
          label="Erneut versuchen"
          icon="pi pi-refresh"
          severity="secondary"
          size="small"
          (onClick)="loadOverview()" />
      </div>
    }

    @case ('processing') {
      <div class="sana-card">
        <p-message severity="info">Ihre Zahlung wird noch verarbeitet.</p-message>

        <p-button
          styleClass="mt-3"
          label="Erneut prüfen"
          icon="pi pi-refresh"
          severity="secondary"
          size="small"
          (onClick)="confirm()" />
      </div>
    }

    @case ('confirm-error') {
      <div class="sana-card">
        <p-message severity="error">
          Der Status konnte nicht geprüft werden. Falls das Problem bestehen bleibt, wenden Sie sich bitte an {{ supportEmail }}.
        </p-message>

        <p-button
          styleClass="mt-3"
          label="Erneut prüfen"
          icon="pi pi-refresh"
          severity="secondary"
          size="small"
          (onClick)="confirm()" />
      </div>
    }

    @case ('ready') {
      <div
        class="sana-card mb-3"
        data-cy="sana-tp-subscription-status">
        <div class="sana-card-header">Ihr Zugang</div>

        @switch (accessState()) {
          @case (TherapistAccessStateEnum.Locked) {
            <p-message severity="warn">Ihr Zugang ist nicht aktiv. Schließen Sie ein Abo ab, um Sanactivo weiter zu nutzen.</p-message>
          }

          @case (TherapistAccessStateEnum.Trial) {
            <p class="m-0">Ihr Testzugang läuft bis {{ testAccountEndsAt() | date:'dd.MM.yyyy' }}.</p>
          }

          @case (TherapistAccessStateEnum.Unlimited) {
            <p class="m-0">Ihr Zugang ist freigeschaltet, ein Abo ist nicht erforderlich.</p>
          }

          @case (TherapistAccessStateEnum.Subscribed) {
            <div class="status-line">
              <span class="plan-name">{{ subscription()?.plan | subscriptionPlanTranslations }}</span>
              <span class="status-label">aktiv</span>
            </div>

            @if (subscription()?.cancelAt) {
              <p class="m-0">Ihr Abo endet am {{ subscription()!.cancelAt | date:'dd.MM.yyyy' }}.</p>
            } @else if (subscription()) {
              <p class="m-0">Ihr Abo verlängert sich am {{ subscription()!.currentPeriodEnd | date:'dd.MM.yyyy' }}.</p>
            }

            <small class="hint mt-2">Kündigung und Änderungen am Abo laufen über den Support: {{ supportEmail }}</small>
          }

          @case (TherapistAccessStateEnum.PaymentOverdue) {
            <div class="status-line">
              <span class="plan-name">{{ subscription()?.plan | subscriptionPlanTranslations }}</span>
              <span class="status-label overdue">Zahlung überfällig</span>
            </div>

            <p-message severity="warn">{{ paymentOverdueMessage }}</p-message>
          }
        }
      </div>

      @if (showPlans()) {
        @if (accessState() === TherapistAccessStateEnum.Trial) {
          <p class="hint mt-0">Das Abo startet sofort, verbleibende Testtage verfallen.</p>
        }

        @if (checkoutError()) {
          <p-message
            severity="error"
            styleClass="mb-3">{{ checkoutError() }}</p-message>
        }

        <div class="row g-3">
          @for (card of planCards; track card.plan) {
            <div class="col-12 col-lg-4">
              <div
                class="sana-card plan-card"
                data-cy="sana-tp-subscription-plan-card">
                <div class="sana-card-header mb-0">{{ card.plan | subscriptionPlanTranslations }}</div>
                <div class="plan-price">{{ card.price }}</div>
                <small class="hint plan-details">{{ card.details }}</small>

                <p-button
                  label="Abo abschließen"
                  severity="primary"
                  [fluid]="true"
                  [disabled]="isRedirecting()"
                  [loading]="checkoutPlan() === card.plan"
                  (onClick)="startCheckout(card.plan)"
                  data-cy="sana-tp-subscription-checkout" />
              </div>
            </div>
          }
        </div>
      }
    }

    @default {
      <!-- 'loading' und 'confirming': Skeleton ohne Plan-Karten -->
      <div
        class="sana-card"
        data-cy="sana-tp-subscription-loading">
        <p-skeleton
          width="12rem"
          styleClass="mb-3" />
        <p-skeleton
          width="100%"
          height="3rem" />
      </div>
    }
  }
</section>
